import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import gButton from "@/components/g-button/g-button.vue";
import AccountLoged from "@/shared/mixins/AccountLoged";

import RepresentanteController from "@/shared/controllers/representante/representanteController";
import UsuarioController from "@/shared/controllers/usuario/usuarioController";
import UsuarioRepresentanteViewModel from "@/shared/view-models/UsuarioRepresentanteViewModel";

export default {
  name:'GerenciamentoRepresentante',
  components: { 
    gCard,
    gForm,
    'g-button': gButton
  }, 
  mixins:[AccountLoged],

  props: { },

  mounted () {
    if(!this.hasClaim('Gerenciamento-Liberação de Representante')) {
      this.$router.push('/sem-acesso')
    }
   },

  updated () { },

  data () {
    return { 
      popup: false,
      excluir: false,
      EmpresaSelecionada: null,
      UsuarioRepresentanteViewModel: new UsuarioRepresentanteViewModel,
      UsuarioSelecionado:null,
      UsuarioArray: [],
      mensagemvazio: true,
      RepresentanteSelecionado:null,
      RepresentantesArray:[],
      novoVinculo:false,
      editarVinculo: false,
      indexEdicao: null,
      AcessoAdministrador: false,
      infoUsuarioRepresentante: [],
      Colunas : [
        {field: 'login', header: 'Login do Usuário'},
        {field: 'nomeUsuario', header: 'Nome do Usuário'},
        {field: 'nomeRepresentante', header: 'Nome do Representante'},
    ],
    }
  },

  methods: { 
    limparFiltro() {
      this.UsuarioRepresentanteViewModel = new UsuarioRepresentanteViewModel
    },
    abrirPopupExcluir (data) {
      this.excluir = true;
      this.UsuarioRepresentanteViewModel.Id = data.id
      this.UsuarioRepresentanteViewModel.UsuarioId = data.usuarioId
      this.UsuarioRepresentanteViewModel.AcessoAdministrador = data.acessoAdministrador
    },
    excluirUsuarioRepresentante(){
      this.$isLoading(true)
      RepresentanteController.excluirUsuarioRepresentante(this.UsuarioRepresentanteViewModel).requisicao
      .then(
        this.getUsuarioRepresentante())
      .finally(()=> {
        this.$isLoading(false)
        this.fechaPopup()
      })
    },
    buscarUsuario(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        UsuarioController.getUsuarios(event).requisicao
        .then((res => {
          this.UsuarioArray = res.data.data
        }))
      }, 1000);
    },
    buscarRepresentante(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.RepresentantesArray = RepresentanteController.getRepresentanteByPesquisa(this.EmpresaSelecionada, event).RepresentanteArray;
      }, 1000);
    },
    abrirPopupNovoVinculo() {
      this.UsuarioSelecionado = null
      this.RepresentanteSelecionado = null
      this.fechaPopup()
      this.popup = true;
      this.novoVinculo=true;
    },
    fechaPopup(){
      this.excluir = false;
      this.popup = false;
      this.editarVinculo=false;
      this.novoVinculo=false;
    },
    abrirPopupEdicao(data, index){
     this.AcessoAdministrador = data.acessoAdministrador;
      this.fechaPopup()
      this.indexEdicao = index;
      this.RepresentanteSelecionado = data.representanteId;
      this.RepresentantesArray = [{
        "id":data.id,
        "codigoNomeRepresentante": data.nomeRepresentante,
        "nomeRepresentante": data.nomeRepresentante,
        "nomeUsuario": data.nomeUsuario,
        "representanteId": data.representanteId,
        "usuarioId": data.usuarioId
        }]
      this.UsuarioArray = [{"id":data.usuarioId, "nomeRepresentante": data.nomeRepresentante, "nomeUsuario": data.nomeUsuario, "representanteId": data.representanteId, "UsuarioRelacaoId": data.id}]
      this.UsuarioSelecionado = data.usuarioId;
      this.popup = true;
      this.editarVinculo=true;

      this.idexiste = data.id
    },
    postUsuarioRepresentante(){
    this.$isLoading(true)

      // let usuarioElem = this.UsuarioArray.find((Element) => Element.id === this.UsuarioSelecionado)
      // this.UsuarioRepresentanteViewModel.Id = usuarioElem.UsuarioRelacaoId
      this.UsuarioRepresentanteViewModel.UsuarioId = (this.UsuarioSelecionado)
      this.UsuarioRepresentanteViewModel.RepresentanteId = this.RepresentanteSelecionado
      this.UsuarioRepresentanteViewModel.Edicao = this.editarVinculo
      this.UsuarioRepresentanteViewModel.AcessoAdministrador = this.AcessoAdministrador

      if(this.idexiste != null)
      {
        this.UsuarioRepresentanteViewModel.Id = this.idexiste
      }
 
      RepresentanteController.postUsuarioRepresentante(this.UsuarioRepresentanteViewModel).requisicao
      .then((response => {
        this.UsuarioRepresentanteViewModel.UsuarioId = null
        this.UsuarioRepresentanteViewModel.RepresentanteId = null
        this.UsuarioRepresentanteViewModel.Edicao = false
        this.UsuarioRepresentanteViewModel.AcessoAdministrador = false
        
        //criando um vinculo que não é adm
        if(response.data.data == true && this.editarVinculo == false && this.AcessoAdministrador == false) {
          this.$toast.add({ severity: 'success', summary: 'Vínculo criado com sucesso!', life: 5000 });

        }
        if(response.data.data == true && this.editarVinculo == true && this.AcessoAdministrador == false) {
          this.$toast.add({ severity: 'success', summary: 'Vínculo atualizado com sucesso!', life: 5000 });

        }
        //erro na criacao de um vinculo do 0
        if(response.data.data == false && this.editarVinculo == false && this.AcessoAdministrador == false) {
          this.$toast.add({ severity: 'error', summary: 'Esse vinculo já existe! Faça uma edição ou crie um novo vinculo.', life: 7000 });

        }
        if(response.data.data == false && this.editarVinculo == true && this.AcessoAdministrador == false) {
          this.$toast.add({ severity: 'error', summary: 'Erro na atualização do vinculo.', life: 5000 });

        }
        if(response.data.data == true && this.editarVinculo == false && this.AcessoAdministrador == true) {
          this.$toast.add({ severity: 'success', summary: 'Acesso de ADM criado com sucesso!', life: 5000 });

        }
        if(response.data.data == true && this.editarVinculo == true && this.AcessoAdministrador == true) {
          this.$toast.add({ severity: 'success', summary: 'Acesso de ADM atualizado com sucesso!', life: 5000 });

        }
        //erro na criacao de um vinculo do 0
        if(response.data.data == false && this.editarVinculo == false  &&  this.AcessoAdministrador == true) {
          this.$toast.add({ severity: 'error', summary: 'Acesso de adm já existente para este usuário', life: 7000 });

        }

        if(response.data.data == false && this.editarVinculo == true  &&  this.AcessoAdministrador == true) {
          this.$toast.add({ severity: 'error', summary: 'Erro na edição de acesso de adm', life: 7000 });

        }
        this.getUsuarioRepresentante()
      }))
      .finally(()=> {
        this.$isLoading(false)
        this.fechaPopup();
      })
    },
    getUsuarioRepresentante(){
      RepresentanteController.getUsuarioRepresentante(this.UsuarioRepresentanteViewModel).requisicao
      .then((res => {
        this.mensagemvazio = false;
        this.infoUsuarioRepresentante = res.data.data
      }))
    }
  },

  computed: { }, 

};